import CustomDrawer from 'components/commom/CustomDrawer';
import { useEffect, useState } from 'react';
import CloseIcon from '@mui/icons-material/Close';
import { CircularProgress, IconButton } from '@mui/material';
import LabelWithInput from 'components/commom/LabelWithPracticeInput';
import 'assets/styles/common.scss';
import SelectInput from 'components/commom/SelectInput';
import { useDispatch, useSelector } from 'react-redux';
import CommonToast from 'components/commom/CommonToast';
import { useNavigate } from 'react-router-dom';
import { getDoctorDrop } from 'store/getDoctorListDropdown/getDoctorListDropdownAction';
import { ClearTokenRedirectLogin } from 'utils/general';
import { createLocationCallAPI } from 'store/EnterpriseAdmin/Location/createLocation/action';
import { updateLocationCallAPI } from 'store/EnterpriseAdmin/Location/updateLocation/action';
import AddIcon from '@mui/icons-material/Add';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import ReusableTabs from 'components/commom/Tab';

const CreateProduct = ({ open, onClose, editData }) => {
  const dispatch = useDispatch();
  const { showToast } = CommonToast();
  const navigate = useNavigate();
  const [formValue, setFormValue] = useState({
    photos: [],
    name: '',
    description: '',
    shelves: '',
    currency: '',
    price: '',
    compareAtPrice: '',
    tab: 1,
    link: '',
    integrationId: '',
    vendorCode: '',
    category: [],
    concerns: [],
    skinTypes: [],
    whenToApply: [],
  });
  const [formSlug, setFormSlug] = useState({
    currency: '',
  });

  const enterpriseData = useSelector(
    (state) => state?.getEnterpriseProfileReducer?.users?.data
  );
  const categoryData = useSelector(
    (state) => state?.getAllCategoryListReducer?.users?.data
  );
  const skinConcernsData = useSelector(
    (state) => state?.getSkinConcernsReducer?.users?.data
  );
  const skinTypesData = useSelector(
    (state) => state?.getSkinTypesReducer?.users?.data
  );

  const modules = {
    toolbar: [
      [{ header: [] }],
      ['bold', 'italic', 'underline', 'strike'],
      [{ list: 'ordered' }, { list: 'bullet' }],
      [{ align: [] }],
      ['link', 'image'],
      ['clean'],
    ],
  };

  const formats = [
    'header',
    'bold',
    'italic',
    'underline',
    'strike',
    'list',
    'bullet',
    'align',
    'link',
    'image',
  ];

  const linkYourProductData = [
    { id: 1, label: 'Link' },
    { id: 2, label: 'Integration' },
  ];

  const currencyData = [{ id: 1, name: 'USD', slug: 'usd' }];

  const whenToApplyData = [
    { id: 1, name: 'AM', slug: 'am' },
    { id: 2, name: 'PM', slug: 'pm' },
  ];

  useEffect(() => {
    if (open) {
      initialState();
    }
  }, [open]);

  const initialState = () => {
    setFormValue({
      photos: [],
      name: '',
      description: '',
      shelves: '',
      currency: '',
      price: '',
      compareAtPrice: '',
      tab: 1,
      link: '',
      integrationId: '',
      vendorCode: '',
      category: [],
      concerns: [],
      skinTypes: [],
      whenToApply: [],
    });
    // setFormSlug({});
  };

  const handleBack = () => {
    onClose();
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    if (name === 'currency') {
      setFormValue((prev) => ({
        ...prev,
        [name]: value?.name,
      }));
      setFormSlug((prev) => ({
        ...prev,
        [name]: value?.slug,
      }));
    } else {
      setFormValue((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  const handleDescription = (fieldName, content) => {
    setFormValue((prev) => ({
      ...prev,
      [fieldName]: content,
    }));
  };

  const handleTabChange = (val) => {
    setFormValue((prev) => ({
      ...prev,
      ['tab']: val,
    }));
    // const tab = productInventoryData[val - 1];
    // setFormValue((prev) => ({
    //   ...prev,
    //   ['tab']: val,
    //   ['productInventory']: tab,
    // }));
  };

  const handleChange = (data, field) => {
    setFormValue((prev) => {
      const current = prev[field] || [];
      const exists = current.some((item) => item.id === data.id);
      return {
        ...prev,
        [field]: exists
          ? current.filter((item) => item.id !== data.id)
          : [...current, data],
      };
    });
  };

  const handleSave = () => {
    // if (
    //   !formValue?.address ||
    //   !formValue?.city ||
    //   !formValue?.state ||
    //   !formValue?.country ||
    //   !formValue?.postalCode
    // ) {
    //   showToast('Please fill all the required fields', 'error');
    //   return;
    // }
    // const body = {
    //   id: editData?.id,
    //   detail: {
    //     name: formValue?.locationName
    //       ? formValue?.locationName
    //       : enterpriseData?.enterprise?.enterprise_name,
    //     address: formValue?.address,
    //     city: formValue?.city,
    //     state: formValue?.state,
    //     country: formValue?.country,
    //     postal_code: formValue?.postalCode,
    //   },
    //   enterpriseId: enterpriseData?.enterprise?.enterprise_id,
    // };
    // if (editData?.id) {
    //   dispatch(
    //     updateLocationCallAPI(body, {
    //       run: true,
    //       handleFunction: (res) => {
    //         showToast(res?.message, 'success');
    //         handleBack();
    //       },
    //       authorize: true,
    //       handleAuthorizeFunction: (res) => {
    //         ClearTokenRedirectLogin(navigate);
    //       },
    //       error: true,
    //       handleErrorFunction: (res) => {
    //         showToast(res?.message, 'error');
    //       },
    //     })
    //   );
    // } else {
    //   dispatch(
    //     createLocationCallAPI(body, {
    //       run: true,
    //       handleFunction: (res) => {
    //         showToast(res?.message, 'success');
    //         handleBack();
    //       },
    //       authorize: true,
    //       handleAuthorizeFunction: (res) => {
    //         ClearTokenRedirectLogin(navigate);
    //       },
    //       error: true,
    //       handleErrorFunction: (res) => {
    //         showToast(res?.message, 'error');
    //       },
    //     })
    //   );
    // }
  };

  return (
    <CustomDrawer
      open={open}
      onClose={() => {
        handleBack();
      }}
      width={{ xs: '100vw', md: '70vw', xl: '40vw' }}
    >
      <div className="relative h-full min-h-[400px] flex flex-col">
        <div className="flex-1 overflow-y-auto p-[25px] pb-[15%]">
          <div className="mt-[43px]">
            <div className="flex items-center justify-between gap-[20px]">
              <p className="p-0 m-0 text-[24px] text-[#292D32] family_outfit_semiBold_600 lh-176">
                Add New Product
              </p>
              <IconButton onClick={handleBack}>
                <CloseIcon />
              </IconButton>
            </div>
            <div className="mt-[24px]">
              <div className="text-[14px] lh-201 family_outfit_medium_500 fc-292D32">
                Photos
              </div>
              <div className="mt-[8px]">
                <div className="border-1 border-[#BBBBBB] bg-[#F7F8FA] h-[106px] w-[106px] border-dashed rounded-[10px] flex items-center justify-center cursor-pointer">
                  <AddIcon />
                </div>
              </div>
              <div className="mt-[8px]">
                <div className="text-[14px] lh-201 family_outfit_regular_400 text-[#ABABAB]">
                  Up to 5 mb, PNG, JPEG or WEBP
                </div>
              </div>
            </div>
            <div className="mt-[40px]">
              <div className="text-[18px] lh-201 family_outfit_semiBold_600 fc-292D32">
                General information
              </div>
            </div>
            <div className="mt-[16px]">
              <LabelWithInput
                label={<>Name</>}
                placeholder="Name"
                name="name"
                type="text"
                value={formValue?.name}
                onChange={(e) => handleInputChange(e)}
              />
            </div>
            <div className="mt-[16px]">
              <div className="text-[14px] lh-201 family_outfit_medium_500 fc-292D32">
                Description
              </div>
              <div className="mt-[11px]">
                <div className="text-[14px] lh-201 family_outfit_regular_400 text-[#737373]">
                  Description is required to automatically tag your products
                  with HautAI Recommendation Engine. Description will be also
                  visible to your users in the Skin Consultant App interface
                </div>
                <div className="mt-[16px] overflow-hidden [&_.ql-editor]:h-[200px] [&_.ql-editor]:overflow-y-auto">
                  <ReactQuill
                    theme="snow"
                    value={formValue?.description}
                    onChange={(content) =>
                      handleDescription('description', content)
                    }
                    modules={modules}
                    formats={formats}
                    // placeholder={'Description ....'}
                  />
                </div>
              </div>
            </div>
            <div className="mt-[16px]">
              <LabelWithInput
                label={<>Shelves</>}
                placeholder="(Sample) Shelf"
                name="shelves"
                type="text"
                value={formValue?.shelves}
                onChange={(e) => handleInputChange(e)}
              />
            </div>
            <div className="mt-[18px] border-1 border-[#D2D2D2] rounded-[6px]">
              <div className="text-[14px] lh-201 family_outfit_medium_500 fc-292D32 p-[10px] border-b border-[#D2D2D2]">
                Tags
              </div>
              <div className="p-[16px]">
                <div>
                  <div className="text-[16px] lh-201 family_outfit_semiBold_600 fc-292D32">
                    Category
                  </div>
                  <div className="mt-[8px] flex flex-wrap gap-[10px]">
                    {categoryData?.map((data, index) => (
                      <div
                        key={index}
                        className={`p-[5px] rounded-[6px] text-[14px] family_outfit_medium_500 lh-16 h-[30px] cursor-pointer flex items-center justify-center border-1 border-[#998A7B] ${formValue?.category?.some((item) => item.id === data?.id) ? 'bg-[#874529] text-white' : 'text-[#874529]'}`}
                        onClick={() => {
                          handleChange(data, 'category');
                        }}
                      >
                        <div>{data?.name}</div>
                      </div>
                    ))}
                  </div>
                </div>
                <div className="mt-[30px]">
                  <div className="text-[16px] lh-201 family_outfit_semiBold_600 fc-292D32">
                    Concerns
                  </div>
                  <div className="mt-[8px] flex flex-wrap gap-[10px]">
                    {skinConcernsData?.map((data, index) => (
                      <div
                        key={index}
                        className={`p-[5px] rounded-[6px] text-[14px] family_outfit_medium_500 lh-16 h-[30px] cursor-pointer flex items-center justify-center border-1 border-[#998A7B] ${formValue?.concerns?.some((item) => item.id === data?.id) ? 'bg-[#874529] text-white' : 'text-[#874529]'}`}
                        onClick={() => {
                          handleChange(data, 'concerns');
                        }}
                      >
                        <div>{data?.name}</div>
                      </div>
                    ))}
                  </div>
                </div>
                <div className="mt-[30px]">
                  <div className="text-[16px] lh-201 family_outfit_semiBold_600 fc-292D32">
                    Skin Types
                  </div>
                  <div className="mt-[8px] flex flex-wrap gap-[10px]">
                    {skinTypesData?.map((data, index) => (
                      <div
                        key={index}
                        className={`p-[5px] rounded-[6px] text-[14px] family_outfit_medium_500 lh-16 h-[30px] cursor-pointer flex items-center justify-center border-1 border-[#998A7B] ${formValue?.skinTypes?.some((item) => item.id === data?.id) ? 'bg-[#874529] text-white' : 'text-[#874529]'}`}
                        onClick={() => {
                          handleChange(data, 'skinTypes');
                        }}
                      >
                        <div>{data?.name}</div>
                      </div>
                    ))}
                  </div>
                </div>
                <div className="mt-[30px]">
                  <div className="text-[16px] lh-201 family_outfit_semiBold_600 fc-292D32">
                    When to apply
                  </div>
                  <div className="mt-[8px] flex flex-wrap gap-[10px]">
                    {whenToApplyData?.map((data, index) => (
                      <div
                        key={index}
                        className={`p-[5px] rounded-[6px] text-[14px] family_outfit_medium_500 lh-16 h-[30px] cursor-pointer flex items-center justify-center border-1 border-[#998A7B] ${formValue?.whenToApply?.some((item) => item.id === data?.id) ? 'bg-[#874529] text-white' : 'text-[#874529]'}`}
                        onClick={() => {
                          handleChange(data, 'whenToApply');
                        }}
                      >
                        <div>{data?.name}</div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
            <div className="mt-[18px] border-1 border-[#D2D2D2] rounded-[6px]">
              <div className="text-[14px] lh-201 family_outfit_medium_500 fc-292D32 p-[10px] border-b border-[#D2D2D2]">
                Price
              </div>
              <div className="p-[16px] grid grid-cols-3 gap-[10px]">
                <div>
                  <SelectInput
                    label={<>Currency</>}
                    placeholder={'Currency'}
                    colorIcon={'#292D32'}
                    name={'currency'}
                    value={formValue?.currency}
                    data={currencyData || []}
                    onChange={handleInputChange}
                  />
                </div>
                <div>
                  <LabelWithInput
                    label={<>Price</>}
                    placeholder="Price"
                    name="price"
                    type="text"
                    value={formValue?.price}
                    onChange={(e) => handleInputChange(e)}
                  />
                </div>
                <div>
                  <LabelWithInput
                    label={<>Compare-at-price</>}
                    placeholder="Compare-at-price"
                    name="compareAtPrice"
                    type="text"
                    value={formValue?.compareAtPrice}
                    onChange={(e) => handleInputChange(e)}
                  />
                </div>
              </div>
            </div>
            <div className="mt-[18px] border-1 border-[#D2D2D2] rounded-[6px] p-[16px]">
              <div className="text-[14px] lh-201 family_outfit_medium_500 fc-292D32">
                Link to your product to your website
              </div>
              <div className="mt-[12px] text-[14px] lh-201 family_outfit_regular_400 text-[#737373]">
                A product link is required so users can open the product page
                from the Skin Consultant App. An Integration ID and Vendor Code
                are required to allow users to add products to their cart from
                the Skin Consultant App.
              </div>
              <div className="mt-[12px]">
                <ReusableTabs
                  tabs={linkYourProductData}
                  defaultTab={formValue?.tab}
                  currentTab={(val) => handleTabChange(val)}
                  background={'#864629'}
                  color={'#FFFFFF'}
                  tabColor={'#A2A2A2'}
                  completeColor={'#FFFFFF'}
                  boxShadow={'0px 3px 16px 0px #00000014'}
                />
              </div>
              <div className="mt-[20px]">
                {formValue?.tab === 1 && (
                  <>
                    <LabelWithInput
                      label={<>Link</>}
                      placeholder="Link"
                      name="link"
                      type="text"
                      value={formValue?.link}
                      onChange={(e) => handleInputChange(e)}
                    />
                  </>
                )}
                {formValue?.tab === 2 && (
                  <>
                    <div>
                      <LabelWithInput
                        label={<>Integration ID</>}
                        placeholder="Integration ID"
                        name="integrationId"
                        type="text"
                        value={formValue?.integrationId}
                        onChange={(e) => handleInputChange(e)}
                      />
                    </div>
                    <div className="mt-[16px]">
                      <LabelWithInput
                        label={<>Vendor Code</>}
                        placeholder="Vendor Code"
                        name="vendorCode"
                        type="text"
                        value={formValue?.vendorCode}
                        onChange={(e) => handleInputChange(e)}
                      />
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
        {/* Absolutely Positioned Bottom Button */}
        <div
          className="mt-[30px] absolute left-0 bottom-0 w-full bg-[#375241] p-[30px] cursor-pointer"
          onClick={() => {
            handleSave();
          }}
        >
          <div className="text-[24px] text-white family_outfit_semiBold_600 lh-176 text-center flex items-center justify-center gap-[10px]">
            {'Create'}
            {false ? (
              <CircularProgress size={24} color="inherit" />
            ) : (
              <span
                style={{ width: 24, height: 24, display: 'inline-block' }}
              />
            )}
          </div>
        </div>
      </div>
    </CustomDrawer>
  );
};

export default CreateProduct;
